<template>
  <div class="pos-ticket-screen">
    <div class="pos-ticket-body">
      <div v-if="loading" class="pos-ticket-status">
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
        Cargando ticket...
      </div>
      <div v-else-if="error" class="pos-ticket-status text-danger">
        {{ error }}
        <button type="button" class="btn btn-sm btn-outline-secondary mt-3" @click="close">
          Volver
        </button>
      </div>
      <iframe
        v-else-if="ticketHtml"
        ref="ticketFrame"
        class="pos-ticket-iframe"
        :srcdoc="ticketHtml"
        title="Ticket de venta"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PosTicket",
  data() {
    return {
      ticketHtml: "",
      loading: true,
      error: "",
    };
  },
  computed: {
    remissionId() {
      return this.$route.params.id;
    },
    returnPath() {
      const q = this.$route.query.returnTo;
      if (typeof q === "string" && q.startsWith("/")) {
        return q;
      }
      return "/pos";
    },
  },
  async mounted() {
    this.$store.state.hideConfigButton = true;
    window.addEventListener("message", this.onTicketMessage);
    await this.loadTicket();
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    window.removeEventListener("message", this.onTicketMessage);
  },
  methods: {
    onTicketMessage(event) {
      if (event?.data?.type === "pos-ticket-close") {
        this.close();
      }
    },
    async loadTicket() {
      this.loading = true;
      this.error = "";
      try {
        const html = await this.$store.dispatch(
          "remissions/getDocPOSHtml",
          this.remissionId
        );
        this.ticketHtml = html || "";
        if (!this.ticketHtml) {
          this.error = "No se recibió contenido del ticket.";
        }
      } catch (err) {
        console.error("Error al cargar ticket:", err);
        this.error =
          err?.data?.message ||
          err?.response?.data?.message ||
          "No se pudo cargar el ticket.";
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$router.push(this.returnPath);
    },
  },
};
</script>

<style scoped>
.pos-ticket-screen {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
}

.pos-ticket-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pos-ticket-iframe {
  flex: 1;
  width: 100%;
  border: none;
  background: #fff;
}

.pos-ticket-status {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #67748e;
  font-size: 0.95rem;
}
</style>
